/* eslint-disable no-lonely-if */
/**
 * @see https://stackoverflow.com/a/16363437
 */

/**
 * Returns a "nice" number approximately equal to range Rounds
 * the number if round = true Takes the ceiling if round = false.
 *
 * @param {number} range  the data range
 * @param {boolean} round whether to round the result
 * @return {number} a "nice" number to be used for the data range
 */
function niceNum(range, round) {
  const exponent = Math.floor(Math.log10(range));
  const fraction = range / 10 ** exponent;
  let niceFraction;

  if (round) {
    if (fraction < 1.5) niceFraction = 1;
    else if (fraction < 3) niceFraction = 2;
    else if (fraction < 7) niceFraction = 5;
    else niceFraction = 10;
  } else {
    if (fraction <= 1) niceFraction = 1;
    else if (fraction <= 2) niceFraction = 2;
    else if (fraction <= 5) niceFraction = 5;
    else niceFraction = 10;
  }

  return niceFraction * 10 ** exponent;
}

/**
 * Calculate and update values for tick spacing and nice
 * minimum and maximum data points on the axis.
 */
function calculate() {
  this.range = niceNum(this.maxPoint - this.minPoint, false);
  this.tickSpacing = niceNum(this.range / (this.maxTicks - 1), true);
  this.niceMin = Math.floor(this.minPoint / this.tickSpacing) * this.tickSpacing;
  this.niceMax = Math.ceil(this.maxPoint / this.tickSpacing) * this.tickSpacing;
}

/**
 * Use NiceScale to generate a minimum, maximum and tick spacing for a chart
 *
 * @class
 * @param {number} min the minimum data point on the axis
 * @param {number} max the maximum data point on the axis
 */
function NiceScale(min, max, maxTicks = 10) {
  this.minPoint = min;
  this.maxPoint = max;
  this.maxTicks = maxTicks;
  this.tickSpacing = undefined;
  this.range = undefined;
  this.niceMin = undefined;
  this.niceMax = undefined;

  calculate.call(this);
}

/**
 * Sets the minimum and maximum data points for the axis.
 *
 * @memberof NiceScale
 * @param minPoint the minimum data point on the axis
 * @param maxPoint the maximum data point on the axis
 * @return {undefined}
 */
NiceScale.prototype.setMinMaxPoints = function setMinMaxPoints(minPoint, maxPoint) {
  this.minPoint = minPoint;
  this.maxPoint = maxPoint;
  calculate.call(this);
};

/**
 * Sets maximum number of tick marks we're comfortable with
 *
 * @memberof NiceScale
 * @param {number} maxTicks the maximum number of tick marks for the axis
 */
NiceScale.prototype.setMaxTicks = function setMaxTicks(maxTicks) {
  this.maxTicks = maxTicks;
  calculate.call(this);
};

/**
 * @memberof NiceScale
 */
NiceScale.prototype.getTickSpacing = function getTickSpacing() {
  return this.tickSpacing;
};

/**
 * @memberof NiceScale
 */
NiceScale.prototype.getNiceMin = function getNiceMin() {
  return this.niceMin;
};

/**
 * @memberof NiceScale
 */
NiceScale.prototype.getNiceMax = function getNiceMax() {
  return this.niceMax;
};

export default NiceScale;
